import { EntityAdapter, createEntityAdapter, EntityState } from "@ngrx/entity";
import { PaginationMetaData } from "../../../api/models/pagination-meta-data.model";

import { AccountListItem } from "../../../api/models/admin/account.model";

export const accountsAdapter: EntityAdapter<AccountListItem> =
    createEntityAdapter<AccountListItem>({
        selectId: (account: AccountListItem) => account.Id,
    });

export interface AccountState extends EntityState<AccountListItem> {
    ids: number[];
    entities: any;
    total: number;
    loaded: boolean;

    paginationMetaData: PaginationMetaData;
    searchString: string;
    error:any;
}
